import { Check } from "lucide-react";
import { DropdownMenuGroup, DropdownMenuItem } from "components/common/dropdown/DropDownV2";
import { getWorkspaceSwitcherSubtitle } from "../../workspaceDropdown.utils";
import { WorkspaceImage } from "../WorkspaceImage";
import { WorkspaceSwitcherListProps } from "./WorkspaceSwitcherList.types";

export const WorkspaceSwitcherList = ({
  workspaces,
  activeWorkspaceId,
  onSwitchWorkspace,
  onClose,
}: WorkspaceSwitcherListProps) => (
  <DropdownMenuGroup className="max-h-56 overflow-y-auto">
    {workspaces.map((workspace) => {
      const isActive = workspace.id === activeWorkspaceId;

      return (
        <DropdownMenuItem
          key={workspace.id}
          aria-current={isActive ? "true" : undefined}
          onClick={() => {
            if (!isActive) {
              onSwitchWorkspace(workspace.id);
            }
            onClose();
          }}
        >
          <WorkspaceImage
            workspaceId={workspace.id}
            workspaceName={workspace.name}
            imagePath={workspace.imagePath}
            isActive={isActive}
            size="md"
          />
          <div className="grid min-w-0 flex-1 leading-tight">
            <span className="truncate text-sm text-foreground">{workspace.name}</span>
            <span className="truncate text-xs text-muted-foreground">
              {getWorkspaceSwitcherSubtitle(workspace.role, workspace.projects.length)}
            </span>
          </div>
          {isActive ? <Check className="h-4 w-4 shrink-0 text-primary" aria-hidden /> : null}
        </DropdownMenuItem>
      );
    })}
  </DropdownMenuGroup>
);
